import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import Card from "@material-ui/core/Card";
// import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import "./card1.css";
import imgTotalUsers from "../assets/dashboard-users-icon.png";
import imgCustomers from "../assets/dashboard-customers-icon.png";
import imgContacts from "../assets/dashboard-contacts-icon.png";
import imgCampaings from "../assets/dashboard-campaigns-icon.png";
import imgLeads from "../assets/dashboard-leads-icon.png";
// import megaphone from "../assets/megaphone.png";
// import network1 from "../assets/network1.png";
// import Icons from "../assets/Icons.png";
// import recruitment from "../assets/recruitment.png";
import Monitorlogo from "../assets/Monitorlogo.png";
import LiveCompaignIcon from "../assets/rocket.svg";
import ConnectRateIcon from "../assets/marketing.svg";
import TotalEngagedIcon from "../assets/market.svg";
import TotalLeadIcon from "../assets/target.svg";
import { Link } from "react-router-dom";

// const useStyles = makeStyles({

// });

function MediaCard(props) {
  function calculate() {
    let length = "";
    switch (props.header) {
      case "CAMPAIGNS":
        return (
          <div className="CampaignDetails">
            <div className="DataBox">
              <div className="dataValue">
                {" "}
                <h5>{props.DashboardData.LiveCompaign}</h5>{" "}
                <span> ({props.DashboardData.TotalCampaign})</span>
              </div>

              <h5 className="status">{"Live Campaigns"}</h5>
            </div>
            <div className="icons">
              <img src={LiveCompaignIcon} alt="users" />
            </div>
          </div>
        );
      case "CONNECT RATE":
        return (
          <div className="CampaignDetails">
            <div className="DataBox">
              <div className="dataValue">
                {" "}
                <h5>{props.DashboardData.TotalConnectRate}%</h5>{" "}
              </div>

              <h5 className="status">{"Total Connect Rate"}</h5>
            </div>
            <div className="icons">
              <img src={ConnectRateIcon} alt="users" />
            </div>
          </div>
        );
      case "% ENGAGED":
        return (
          <div className="CampaignDetails">
            <div className="DataBox">
              <div className="dataValue">
                {" "}
                <h5>{props.DashboardData.TotalEngaged}%</h5>{" "}
              </div>

              <h5 className="status">{"Total Engaged"}</h5>
            </div>
            <div className="icons">
              <img src={TotalEngagedIcon} alt="users" />
            </div>
          </div>
        );
      case "% LEADS":
        return (
          <div className="CampaignDetails">
            <div className="DataBox">
              <div className="dataValue">
                {" "}
                <h5>{props.DashboardData.TotalLeads}%</h5>{" "}
              </div>

              <h5 className="status">{"Total Leads"}</h5>
            </div>
            <div className="icons">
              <img src={TotalLeadIcon} alt="users" />
            </div>
          </div>
        );
      case "Monitoring":
        return (
          <div className="info">
            <div>
              <img src={Monitorlogo} alt="users" width="75%" />
            </div>
          </div>
        );
      case "Users":
        return (
          <div className="info">
            <div>
              <img src={imgTotalUsers} alt="users" width="75%" />
            </div>
            <div>
              <span className="cardNumber">
                {
                  (length =
                    props.totalCounts === "" ||
                    props.totalCounts.allUsersdata === null
                      ? 0
                      : props.totalCounts.allUsersdata.totalCount)
                }
              </span>
              <span className="cardContent">Total {props.header}</span>
            </div>
          </div>
        );
      case "Customers":
        return (
          <div className="info">
            <div>
              <img src={imgCustomers} alt="Customers" width="75%" />
            </div>
            <div>
              <span className="cardNumber">
                {
                  (length =
                    props.totalCounts === "" ||
                    props.totalCounts.allCustomers === null
                      ? 0
                      : props.totalCounts.allCustomers.totalCount)
                }
              </span>
              <span className="cardContent">Total {props.header}</span>
            </div>
          </div>
        );
      case "Contacts":
        return (
          <div className="info">
            <div>
              <img src={imgContacts} alt="contacts" width="75%" />
            </div>
            <div>
              <span className="cardNumber">
                {
                  (length =
                    props.totalCount === "" ||
                    props.totalCount.allContacts === null
                      ? 0
                      : props.totalCount.allContacts.totalCount)
                }
              </span>
              <span className="cardContent">Total {props.header}</span>
            </div>
          </div>
        );
      case "Campaigns":
        return (
          <div className="info">
            <div>
              <img src={imgCampaings} alt="Campaigns" width="75%" />
            </div>
            <div>
              <span className="cardNumber">
                {
                  (length =
                    props.totalCounts === "" ||
                    props.totalCounts.allCampaigns === null
                      ? 0
                      : props.totalCounts.allCampaigns.totalCount)
                }
              </span>
              <span className="cardContent">Total {props.header}</span>
            </div>
          </div>
        );
      case "Leads":
        return (
          <div className="info">
            <div>
              <img src={imgLeads} alt="Leads" width="75%" />
            </div>
            <div>
              <span className="cardNumber">
                {
                  (length =
                    props.totalCount === "" || props.totalCount.leads === null
                      ? 0
                      : props.totalCount.leads.totalCount)
                }
              </span>
              <span className="cardContent">Total {props.header}</span>
            </div>
          </div>
        );
      default:
    }
  }

  function onClickCard(currentHeader) {
    props.onClickCard(currentHeader);
  }

  return (
    <div className="cardComponent">
      <Link
        to={props.headerPath}
        onClick={() => {
          localStorage.setItem("path", props.headerPath);

          onClickCard(props.currentHeader);
        }}
      >
    
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {calculate()}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
          ></Typography>
        </CardContent>
        
      </Link>
    </div>
  );
}

export default MediaCard;
